let cacheServed = 0;
let remoteServed = 0;

export function logHistoryCacheServe(count: number) {
  cacheServed += count;
  console.log(
    `[SyncStats] Served ${count} cached history entries (cache hits so far: ${cacheServed}).`,
  );
}

export function logHistoryRemoteServe(count: number) {
  remoteServed += count;
  console.log(
    `[SyncStats] Fetched ${count} remote history entries (remote hits so far: ${remoteServed}).`,
  );
}
